/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { gaugeAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type StakeLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  gaugeAddress: Address
  amount: bigint
}

export const stakeLiquidity = async ({
  account,
  chainId,
  config,
  gaugeAddress,
  amount,
}: StakeLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: gaugeAbi as Abi,
        account,
        address: gaugeAddress,
        args: [amount],
        chainId,
        functionName: "deposit",
      },
    })
    return result
  } catch (error: any) {
    console.error("stakeLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
